import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeLanguage } from '../../../state/actions/creators/app.actioncreator';
import { Text } from '../../shared/components';

class LanguageSelector extends React.Component {
  render() {
    const { idiomas, idioma, changeLanguage } = this.props;
    if (idiomas === null || idiomas === undefined) return null;
    const MenuItems = idiomas.map((idioma) => {
      const { key, label } = idioma;
      return (
        <Menu.Item key={key}>
          <Button type="link" onClick={() => changeLanguage({ idioma: key })}>
            <Text style={{ textTransform: 'capitalize' }}>{label.toLowerCase()}</Text>
          </Button>
        </Menu.Item>
      );
    });

    const idiomaSeleccionado = idioma ? idioma.toUpperCase() : 'X';

    return (
      <Dropdown
        overlay={(
          <Menu>
            { MenuItems }
          </Menu>
        )}
      >
        <Button style={{ height: '64px' }} type="link">
          <Text color="white">{ idiomaSeleccionado }</Text>
        </Button>
      </Dropdown>
    );
  }
}

const mapStateToProps = (sagas) => {
  const { app: { idioma }, core: { idiomas } } = sagas;
  return {
    idioma,
    idiomas,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeLanguage,
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
